import { getCookie } from '@/utils/cookie';
import { getHomePageDataByUrl } from '@/api/content';
import Constants from '@/constants/const';
import { useEffect, useState } from 'react';
import useSWR from 'swr';

type Props = {
  data?: any;
  postUrl?: string;
  componentDataSourceKey?: string;
  isStatic: boolean;
};

const fetcher = params => {
  const { postUrl, ...rest } = JSON.parse(params);
  return getHomePageDataByUrl(postUrl, rest);
};

const useFetch = (props: Props) => {
  const { postUrl, componentDataSourceKey, isStatic } = props;

  const zipcode = getCookie(Constants.ZIP_CODE);
  const lang = getCookie(Constants.LANGUAGE);
  const date = getCookie(Constants.DELIVERY_DATE);

  const { data, error, mutate } = useSWR(
    !isStatic
      ? JSON.stringify({
          postUrl,
          zipcode,
          lang,
          date,
          dataobject_key: componentDataSourceKey
        })
      : null,
    fetcher,
    {
      revalidateOnFocus: false,
      revalidateIfStale: false,
      refreshWhenHidden: false
    }
  );

  return {
    data: isStatic ? props.data : data?.object,
    load: isStatic ? false : !error && !data,
    mutate
  };
};

export default useFetch;
